import BookingManagerContainer from "../../container/admin/booking-manager";

const BookingManager = () => {
    return <BookingManagerContainer />;
};

export default BookingManager;